import { useFormContext } from 'react-hook-form'
import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { PostFormData } from '../types'
import { TYPE_OPTIONS } from '../constants'

export function FormTitleTypeRow() {
  const { register, watch, setValue, formState } = useFormContext<PostFormData>()
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <label className="text-sm font-medium">Título *</label>
        <Input {...register('title')} placeholder="Digite o título" />
        {formState.errors.title && (
          <p className="text-sm text-red-500">{formState.errors.title.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <label className="text-sm font-medium">Tipo *</label>
        <Select
          value={watch('type')}
          onValueChange={(value) => setValue('type', value as PostFormData['type'])}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Selecione o tipo" />
          </SelectTrigger>
          <SelectContent>
            {TYPE_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {formState.errors.type && (
          <p className="text-sm text-red-500">{formState.errors.type.message}</p>
        )}
      </div>
    </div>
  )
}
